/**
 * Creates an object that can be used to trigger the async executor of a promise.
 * Useful together with `React.use(lazyPromise.promise)` where you do not want the promise to execute immediately.
 */
export const createLazyPromise = <T>(asyncFn: () => Promise<T>) => {
  const lazyPromise = {} as { promise: Promise<T>; trigger: () => void };
  lazyPromise.promise = new Promise<T>((resolve, reject) => {
    let triggered = false;
    lazyPromise.trigger = async () => {
      if (triggered) return;
      triggered = true;
      try {
        const result = await asyncFn();
        resolve(result);
      } catch (error) {
        reject(error);
      }
    };
  });
  return lazyPromise;
};
